export function getDegreeReport(
  { institutionId, initialDate, finalDate, dateFilterCriteria, origin } = {},
  onSuccess
) {
  return {
    type: '@degree/REQUEST',
    payload: {
      institutionId,
      initialDate,
      finalDate,
      dateFilterCriteria,
      origin,
      onSuccess,
    },
  };
}
export function getDegreeReportSuccess(data) {
  return {
    type: '@degree/SUCCESS',
    payload: { data },
  };
}

export function getDegreeReportFailure() {
  return {
    type: '@degree/FAILURE',
  };
}
